<template>
  <div class="form-area">
    <div class="form-black-titile">
      成功遞交申請<br>Application Submitted Successfully
    </div>
    <div>
      <img class="success-img" src="../../assets/icon/success.png" />
    </div>

    <div class="form-black-mid-titile">
      我們剛剛發出確認電郵到你郵箱，請立即前往查閱<br>We just sent a confirmation email to your email address, please check immediately
    </div>

    <div class="form-black-titile">
      你的申請編號是：<br>Your Application ID is:<br>{{applyCode}}
    </div>

    <div class="btn-box">
      <el-col :span="4"></el-col>
      <el-button class="next-btn" type="warning" round @click="handleHome">返回主頁<br> Return to home page</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        applyCode: this.Session.get("applyCode")
      }
    },
    methods: {
      handleHome() {
        this.$store.commit("FINISH_SETP");
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/common/applySuccess.vue